import { Controller } from "@hotwired/stimulus"

// Drives the weekly calendar: scrolls the hour grid to the start of the workday
// on load, opens the entry dialog for either adding (a clicked day pre-filled)
// or editing (the form streams into the modal frame over Turbo), and submits the
// user filter when its selection changes.
export default class extends Controller {
  static targets = ["scroll", "dialog", "frame", "template"]
  static values = { offset: Number }

  connect() {
    if (this.hasScrollTarget) this.scrollTarget.scrollTop = this.offsetValue
  }

  openModal({ params }) {
    this.frameTarget.innerHTML = this.templateTarget.innerHTML
    const date = this.frameTarget.querySelector("input[name='time_entry[date]']")
    if (date) date.value = params.date
    this.dialogTarget.showModal()
  }

  openEdit() {
    this.frameTarget.innerHTML = `<div class="p-6 text-sm text-neutral-500">Loading…</div>`
    this.dialogTarget.showModal()
  }

  closeModal() {
    this.dialogTarget.close()
  }

  backdropClose(event) {
    if (event.target === this.dialogTarget) this.dialogTarget.close()
  }

  submitFilter(event) {
    event.target.form.requestSubmit()
  }
}
